import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

import Navbar from "./component/Navbar/navbar";
import Footer from "./component/Footer/Footer";
import ScrollToTop from "./component/ScrollToTop/ScrollToTop";
import WhatsAppButton from "./component/WhatsAppButton/WhatsAppButton";
import PageMeta from "./component/SEO/PageMeta";
import LoadingFallback from "./component/LoadingFallback/LoadingFallback";

import Home from "./component/Home/Home";
const FullAbout = lazy(() => import("./component/About/FullAbt"));
const FullTeam = lazy(() => import("./component/FullTeam/FullTeam"));
const Projects = lazy(() => import("./component/Projects/Projects"));
const ProjectDetail = lazy(() => import("./component/ProjectDetail/ProjectDetail"));
const ServiceDetail = lazy(() => import("./component/ServiceDetail/ServiceDetail"));
const Contact = lazy(() => import("./component/Contact/Contact"));

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* Dynamic SEO metadata, Open Graph and Twitter Card management */}
        <PageMeta />
        {/* ScrollToTop must stay inside Router to work */}
        <ScrollToTop />
        {/* Floating WhatsApp button directly in right bottom corner below ScrollToTop */}
        <WhatsAppButton />
        <Navbar />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<FullAbout />} />
            <Route path="/services" element={<ServiceDetail />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/service/:slug" element={<ServiceDetail />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<ProjectDetail />} />
            <Route path="/project/:slug" element={<ProjectDetail />} />
            <Route path="/fullteam" element={<FullTeam />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;